
import { CostCentreTypeInfoBase } from './cost-centre.typeinfo.base';


export class CostCentreTypeInfo extends CostCentreTypeInfoBase {
}

export const COST_CENTRE_TYPE: CostCentreTypeInfo = new CostCentreTypeInfo();



